/**
 * @file Renders the schedule icon of a project in the sidebar, colored by the schedule status.
 */
import React from "react";
import { theme } from "antd";
import { ScheduleOutlined } from "@ant-design/icons";

import { W0 } from "@components/Constants";
import type { ScheduleStatus } from "@api/types";
import { ACTIVE as SCHEDULE_STATUS_ACTIVE } from "@api/services/transactions/shapes/ScheduleStatusEnum";

type Props = {
  status?: ScheduleStatus;
};

// NOTE: the paused color is the text color of the orange tag, which the
//       distributions page shows for a paused schedule.
const PAUSED_COLOR_TOKEN = "orange7";

/**
 * Renders the schedule icon in the color of the menu item text when the schedule is active,
 * in orange when it is paused, and nothing when the project has no schedule.
 */
const ScheduleStatusIcon = ({ status = undefined }: Props): JSX.Element | null => {
  const { token } = theme.useToken();

  if (!status) {
    return null;
  }

  const isActive = status === SCHEDULE_STATUS_ACTIVE;

  const color = isActive
    ? undefined
    : token[PAUSED_COLOR_TOKEN];

  return (
    <ScheduleOutlined
      style={{
        position: "absolute",
        left: W0 - 1,
        top: "50%",
        transform: "translateY(-50%)",
        color,
      }}
    />
  );
};

export default ScheduleStatusIcon;
